export default __webpack_public_path__ + "static/media/Ellipse 80.5437fd8d.svg";